import { render, staticRenderFns } from "./FOURComaScore.vue?vue&type=template&id=39a1cac4&scoped=true&"
import script from "./FOURComaScore.vue?vue&type=script&lang=js&"
export * from "./FOURComaScore.vue?vue&type=script&lang=js&"
import style0 from "./FOURComaScore.vue?vue&type=style&index=0&id=39a1cac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1cac4",
  null
  
)

export default component.exports